import TruckingReactAPI from '../../lib/TruckingReactAPI';
import { handleError, error, receive, request } from '../../lib/Utils';

export const VERSION = {
  path: '/version',
  REQUEST: "VERSION_REQUEST",
  SUCCESS: "VERSION_SUCCESS",
  FAILURE: "VERSION_FAILURE"
};

let api = new TruckingReactAPI({domain: '/api'});

export function getVersion() {
  return (dispatch) => {
    return api
      .getVersion()
      .then((payload) => {        
        if (payload.ok) {          
          payload
            .json()
            .then(json => dispatch(receive(VERSION, json)));
        } else {
          handleError(dispatch, payload, VERSION);          
        }
      })
      .catch(err => dispatch(error(VERSION, err.message)));
  };
}


// WEBPACK FOOTER //
// ./src/containers/SidebarFooter/SidebarFooterActions.js